import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const checkoutCom = defineConnector({
  identifier: "checkoutCom",
  name: "Checkout.com",
  tagLine: "Online payments platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.checkout\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Checkout.com app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Checkout.com access key docs](https://www.checkout.com/docs/developer-resources/access-keys/create-and-manage-your-keys) and create API keys for the environment you want to use. Copy the public and secret credentials for the service account or app you create.",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://access.checkout.com/connect/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.checkout.com/",
  },
});
